// src/views/ModelerPostProcessingView.js
import React, { useState } from "react";
import { Tabs, Tab } from "baseui/tabs-motion";
import { Block } from "baseui/block";
import ModelerPostPorcessingRunPipeline from "./ModelerPostPorcessingRunPipeline";
import ModelerPostPorcessingViewResults from "./ModelerPostPorcessingViewResults"; 

function ModelerPostProcessingView ()  {
  const [activeKey, setActiveKey] = useState("run");

  return (
    <Block padding="scale600">
      <Tabs
        activeKey={activeKey}
        onChange={({ activeKey }) => setActiveKey(activeKey)}
      >
        <Tab title="Run Pipeline" key="run">
          <ModelerPostPorcessingRunPipeline />
        </Tab>
        <Tab title="View 3D Results" key="view">
          <ModelerPostPorcessingViewResults />
        </Tab>
      </Tabs>
    </Block>
  );
};

export default ModelerPostProcessingView;
